// extracted by mini-css-extract-plugin
export var colorSquare = "_u6-0";
export var danger = "_u6-5";
export var lightPink = "_u6-8";
export var neutralBlue = "_u6-7";
export var neutralYellow = "_u6-6";
export var normal = "_u6-1";
export var primary = "_u6-2";
export var primaryLight = "_u6-3";
export var solidBlack = "_u6-g";
export var solidGreen = "_u6-b";
export var solidLightBlue = "_u6-d";
export var solidNavy = "_u6-c";
export var solidOrange = "_u6-f";
export var solidPink = "_u6-e";
export var solidRed = "_u6-9";
export var solidYellow = "_u6-a";
export var success = "_u6-4";